import { type PropsWithChildren, useRef, useState } from 'react';

import { NewDateFilter } from '@hapvida/hapvida-core-components';

import newUseFilterParams from '@hapvida/hapvida-core-components/src/hooks/newUseFilterParams';
import { FilterKeys } from '@hapvida/hapvida-core-components/src/components/NewFilterSummary/constants';

import type {
  FiltersDrawerButtonProps,
  IFilterOptions,
  TFilterValue,
} from '../types';
import { FilterDrawerBase } from '../FilterDrawerBase';
import { formatObjectToFilterUrl } from '../FilterDrawerBase/utils/formatObjectToFilterUrl';

export function NewFilterDrawerFinancial({
  subtitle,
  title,
  ...buttonProps
}: PropsWithChildren<FiltersDrawerButtonProps>) {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const { changeMultiple } = newUseFilterParams({});

  const handleToggleDrawer = () => {
    setVisibleDrawer(!visibleDrawer);
  };

  const dateRangeRef = useRef<{ filterValue: TFilterValue } | null>(null);

  const refs: IFilterOptions = {
    planType: useRef(null),
    contractType: useRef(null),
    profileId: useRef(null),
  };

  const handleApplyAll = () => {
    const rangeDateValueRef: TFilterValue =
      (dateRangeRef?.current && dateRangeRef?.current.filterValue) ?? {};
    let inputsValueObj: TFilterValue = {};

    Object.keys(refs).forEach(key => {
      const ref = refs[key];

      if (ref?.current) {
        inputsValueObj = { ...inputsValueObj, ...ref.current?.filterValue };
      }
    });

    const objectFilterValues = { ...inputsValueObj, ...rangeDateValueRef };

    changeMultiple(formatObjectToFilterUrl(objectFilterValues));
    handleToggleDrawer();
  };

  return (
    <FilterDrawerBase
      title={title}
      subtitle={subtitle}
      handleApplyAll={handleApplyAll}
      {...buttonProps}
    >
      <NewDateFilter
        startDateName={FilterKeys.START_DATE}
        endDateName={FilterKeys.END_DATE}
        ref={dateRangeRef}
      />
    </FilterDrawerBase>
  );
}
